import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Card, CardContent, CardHeader } from "./ui/card";
import { CDNImage } from "./ui/cdn-image";
import type { CcoSelect } from "~/lib/schemas";
import { SimpleCarousel } from "./ui/simple-carousel";
import { getCcos } from "~/lib/ccos";

export const CcoCarousel = () => {
  const { data: response, isLoading } = useQuery({
    queryKey: ["ccos", 12],
    queryFn: () => getCcos({ data: { limit: 12 } }),
  });

  const ccos = response?.ccos;

  const renderCcoCard = (cco: CcoSelect | null) => (
    <Card className="h-full">
      {cco ? (
        <>
          <CardHeader>
            <div className="flex h-12 items-start gap-4">
              {cco.logoUrl && (
                <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center overflow-hidden rounded-md bg-gray-100">
                  <CDNImage
                    src={cco.logoUrl}
                    alt={`${cco.name} logo`}
                    className="h-full w-full object-contain"
                    width={64}
                    height={64}
                  />
                </div>
              )}
              <h3 className="font-heading text-text-primary text-lg font-medium leading-none">
                {cco.name}
              </h3>
            </div>
          </CardHeader>
          <CardContent>
            <p className="text-text-tertiary line-clamp-3 text-sm">
              {cco.description}
            </p>
          </CardContent>
        </>
      ) : (
        <CardContent className="flex h-full w-full items-center justify-center">
          <p className="text-text-tertiary text-sm">And dozens more...</p>
        </CardContent>
      )}
    </Card>
  );

  if (isLoading) {
    return (
      <div className="flex items-center justify-center p-8">
        <p className="text-text-tertiary">Loading CCOs...</p>
      </div>
    );
  }

  if (!ccos) {
    return null;
  }

  return <SimpleCarousel items={[...ccos, null]} renderItem={renderCcoCard} />;
};
